import { CloudDownloadOutlined } from '@mui/icons-material';
import { Box, Badge, Chip, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState, useCallback } from 'react';
import PageContainer from '../../components/PageContainer';
import { getAllUserGeneratedReports, getReportDocByReportId } from '../../redux/api/reports';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { useDropzone } from 'react-dropzone';

const Reports = () => {
    const [processing, setProcessing] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [records, setRecords] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    const columns = [
        {
            field: 'sn',
            headerName: 'S/N',
            width: 80,
            sortable: false,
            renderCell: (params) => {
                return <p style={{ margin: 'auto' }}>{(params?.api?.getRowIndex(params?.row?.id) || 0) + 1}</p>;
            },
        },
        {
            field: 'id',
            headerName: 'Quick Action',
            width: 150,
            sortable: false,
            renderCell: (params) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <IconButton
                        size="small"
                        color="primary"
                        // variant="outlined"
                        onClick={() => downloadFile(params?.row?.id, `${params?.row?.reportTypeName} - ${params?.row?.startTime}`)}
                        title="Download File"
                    >
                        <CloudDownloadOutlined />
                    </IconButton>
                </div>
            ),
        },
        { field: 'reportTypeName', headerName: 'Report Name', width: 250 },
        { field: 'fileType', headerName: 'File Type', width: 200 },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => getStatus(params?.row?.isCompleted ? 'completed' : 'processing'),
        },
        {
            field: 'startTime',
            headerName: 'Start Time',
            width: 250,
            valueGetter: (params) => (params?.row?.startTime ? moment(params?.row?.startTime).format('DD MMMM, YYYY hh:mm A') : ''),
        },
        {
            field: 'completionTime',
            headerName: 'Completion Time',
            width: 250,
            valueGetter: (params) => (params?.row?.completionTime ? moment(params?.row?.completionTime).format('DD MMMM, YYYY hh:mm A') : ''),
        },
    ];

    // SUBMITTED, PROCESSING, PROCESSED
    const getStatus = (status = 'SUBMITTED') => {
        switch (status) {
            case 'SUBMITTED':
                return <Chip size="small" color="info" label={<small>Submitted</small>} />;
            case 'processing':
                return <Chip size="small" color="info" label={<small>Processing</small>} />;
            case 'completed':
                return <Chip size="small" color="primary" label={<small>Completed</small>} />;
            default:
                return <Chip size="small" color="primary" label={<small>Processed</small>} />;
        }
    };

    const init = async () => {
        try {
            setProcessing(true);
            const res = await getAllUserGeneratedReports();
            setRecords(res?.resultObject || []);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const downloadFile = async (id, fileName) => {
        try {
            setDownloading(true);
            await getReportDocByReportId(id, fileName);
        } catch (err) {
            enqueueSnackbar(err?.message || 'Failed to retrieve file', {
                variant: 'error',
            });
        } finally {
            setDownloading(false);
        }
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <PageContainer pageTitle="Reports" processing={processing}>
            <Box>
                <div className="paper" style={{ height: 550, width: '100%', textAlign: 'center' }}>
                    <DataGrid
                        className={'center-first-column'}
                        rows={records || []}
                        getRowId={(row) => row.id}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        checkboxSelection={false}
                        disableSelectionOnClick
                        style={{ fontSize: '12px' }}
                    />
                </div>
            </Box>
        </PageContainer>
    );
};

export default Reports;
